import { render, staticRenderFns } from "./AbaEditarDadosEvento.vue?vue&type=template&id=05bd2c3c"
import script from "./AbaEditarDadosEvento.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosEvento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports